module.exports = __webpack_public_path__ + "img/manhead.64f1f549.png";